import PropTypes from 'prop-types';
import {Helmet} from 'react-helmet';

const Helm = ({title, children}) => (
  <>
    <Helmet>
      <title>{title}</title>
    </Helmet>

    {children}
  </>
);

Helm.propTypes = {
  title: PropTypes.string,
  children: PropTypes.node,
};

export default Helm;
